<template>
  <div>
    <h4 class="text-center text-lighter font-weight-normal mt-5 mb-0">Login via Microsoft</h4>
    <form class="my-5">
      <b-form-group class="mb-0" v-if="errors.length">
        <p class="text-danger" v-for="(error, i) in errors" :key="i">
          <template v-if="error.name"
            ><b>{{ error.name }}</b
            >: {{ error.message }}</template
          >
          <template v-else>{{ error }}</template>
        </p>
      </b-form-group>
      <b-form-group class="mb-0" v-else>
        <p class="text-center">
          We are finishing sign in process. Please wait.
        </p>
      </b-form-group>
    </form>

    <div class="text-center text-muted">
      <router-link :to="{ name: 'login' }">Sign In with Password</router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import redirectAfterLogin from '@/mixins/redirectAfterLogin'

export default {
  name: 'login',
  mixins: [redirectAfterLogin],
  data: () => ({
    errors: [],
    code: ''
  }),
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters(['frontDomain']),
    ...mapGetters('auth', ['isUserOnOwnDomain'])
  },
  methods: {
    ...mapActions('auth', ['loginMs']),
    login() {
      if (this.code) {
        this.loginMs({ code: this.code }).then((r) => {
            this.redirectAfterLogin()
          }, (error) => {
            if (error.response && error.response.data) {
              if (error.response.status === 423) return
              let data = error.response.data
              if (data && data.errors) {
                this.errors = data.errors
              }
            } else {
              throw error
            }
          })
      }
    }
  },
  created() {
    if (this.$route.query) {
      if (this.$route.query.code) {
        this.code = this.$route.query.code
        this.login()
      } else if (this.$route.query.error && this.$route.query.error_description) {
        this.errors.push({ name: this.$route.query.error, message: this.$route.query.error_description })
      } else {
        this.errors.push({ name: 'Code not provided', message: 'Something goes wrong. Authentication code not provided.' })
      }
    }
  }
}
</script>

<style scoped></style>
